<template>
  <div class="add-grupou">
    <h1>Agregar Nuevo Grupo</h1>
    
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <form @submit.prevent="submitForm" class="card p-4 bg-light">
      <div class="mb-3">
        <label for="grupouCode" class="form-label">Cu00f3digo *</label>
        <input 
          type="text" 
          class="form-control" 
          id="grupouCode" 
          :value="grupou.GrupouCode" 
          @input="updateField('GrupouCode', $event.target.value)"
          required
          maxlength="20"
        >
        <small class="form-text text-muted">Código único del grupo (máximo 20 caracteres)</small>
      </div>
      
      <div class="mb-3">
        <label for="grupouName" class="form-label">Nombre</label>
        <input 
          type="text" 
          class="form-control" 
          id="grupouName" 
          :value="grupou.GrupouName"
          @input="updateField('GrupouName', $event.target.value)"
          maxlength="100"
        >
        <small class="form-text text-muted">Nombre del grupo (máximo 100 caracteres)</small>
      </div>
      
      <div class="mb-3 form-check">
        <input 
          type="checkbox" 
          class="form-check-input" 
          id="esActivo" 
          :checked="grupou.EsActivo"
          @change="updateField('EsActivo', $event.target.checked)"
        >
        <label class="form-check-label" for="esActivo">Grupo Activo</label>
      </div>
      
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          <i v-else class="bi bi-save me-1"></i>
          Guardar
        </button>
        <router-link to="/grupous" class="btn btn-secondary">
          <i class="bi bi-x-circle me-1"></i> Cancelar
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import AddGrupouViewController from './AddGrupouController.js';
import { handleResponse } from '../../utils/mgk-response-handler';

export default {
  name: 'AddGrupouView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new AddGrupouViewController()
    }
  },
  computed: {
    grupou() {
      return this.controller.getGrupou();
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getCurrentError();
    }
  },
  created() {
    this.controller.initialize();
  },
  methods: {
    async submitForm() {
      if (!this.controller.validateForm()) {
        this.$alert.error('Por favor, complete todos los campos requeridos.');
        return;
      }

      try {
        const response = await this.controller.saveGrupou();
        handleResponse(response, 'Grupo guardado correctamente.', 'Error al guardar el grupo.');
        if (response.data.Number > 0) {
          this.$router.push('/grupos');
        }
      } catch (error) {
        this.$alert.error('Error al guardar el grupo. Por favor, intente de nuevo.');
      }
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    goBack() {
      this.$router.push('/grupous');
    }
  }
}
</script>

<style scoped>
.add-grupou {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
